import {
  Button,
  Center,
  HStack,
  Icon,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';
import { Modal } from '@diamond/shared/ui';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS } from '@diamond/sol-buyer/constant';
import { ArrowForward } from '@mui/icons-material';
import { useEffect } from 'react';

interface ContactSalesModalProps {
  isOpen: boolean;
  onClose: () => void;
  productId?: string;
  productName?: string;
  source?: 'card' | 'detail';
}

/**
 * Modal shown when user clicks "Tambah Keranjang" on a product with unavailable pricing (price = 0 or N/A).
 * Displays message instructing user to contact sales for pricing information.
 * Tracks GA events for lead identification.
 */
export function ContactSalesModal({
  isOpen,
  onClose,
  productId,
  productName,
  source = 'card',
}: ContactSalesModalProps) {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (isOpen) {
      trackEvent(TRACKING_EVENTS.CONTACT_SALES_MODAL_VIEW, {
        product_id: productId,
        product_name: productName,
        source,
      });
    }
  }, [isOpen, productId, productName, source]);

  const handleConfirm = () => {
    trackEvent(TRACKING_EVENTS.CONTACT_SALES_MODAL_CONFIRM, {
      product_id: productId,
      product_name: productName,
      source,
    });
    onClose();
  };

  return (
    <Modal
      name="contact-sales-modal"
      isOpen={isOpen}
      onClose={onClose}
      size={isMobile ? 'sm' : 'md'}
      isCentered
      hideAction
      hideClose
    >
      <Center p={6} flexDirection="column">
        <HStack spacing={2} mb={4}>
          <Text
            fontSize={{ base: 'lg', md: 'xl' }}
            fontWeight="bold"
            textAlign="center"
          >
            Konfirmasi Harga Terkini
          </Text>
        </HStack>
        <Text textAlign="center" mb={6} color="gray.600">
          Mohon hubungi admin/sales representatif Anda untuk cek harga terkini
          dan pemesanan.
        </Text>
        <Button
          variant="solid"
          bg="blue"
          color="white"
          _hover={{ bg: 'navy' }}
          onClick={handleConfirm}
          w={{ base: 'full', md: '200px' }}
        >
          OK, Mengerti
        </Button>
      </Center>
    </Modal>
  );
}

export default ContactSalesModal;
